"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentObjectFragmentDoc = exports.AttachmentFullFragmentDoc = void 0;
const client_1 = require("@apollo/client");
exports.AttachmentFullFragmentDoc = client_1.gql `
    fragment AttachmentFull on Attachment {
  Type
  FileType
  ObjectId
  FileName
  Comment
  Id
  Url
  PreviewUrl
  LoginId
}
    `;
exports.AttachmentObjectFragmentDoc = client_1.gql `
    fragment AttachmentObject on Attachment {
  FileType
  ObjectId
  FileName
  Comment
  Id
  CreatedAt
  Url
  PreviewUrl
}
    `;
//# sourceMappingURL=Attachment.generated.js.map